import { render, staticRenderFns } from "./PurchaseQuotation.vue?vue&type=template&id=c5de2084"
import script from "./PurchaseQuotation.vue?vue&type=script&lang=js"
export * from "./PurchaseQuotation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports